import { useState, type FC } from 'react';
import { Space } from '@g2u/ui-kit';
import { Form } from 'antd';

import { Actions, Invoice, Method, Receipt, RequestPaymentModal } from '.';
import { useServicePayment } from '../hooks';
import type { JsonDataItem } from 'types';

type Props = {
  jobId?: string;
  isLocked: boolean;
};

export const ServicePayment: FC<Props> = (props) => {
  const { jobId, isLocked } = props;
  const [form] = Form.useForm();
  const {
    paymentMethods,
    paymentMethod,
    step,
    setPaymentMethod,
    generateInvoice,
    sendEmail,
    requestPayment,
    processPayment,
    invoices,
    receipts,
    receiptsTotal,
    outstandingAmount,
    hasDebt,
    hasCard,
    isDataLoading,
    isJobUpdating,
    emailOptions,
    smsOptions,
    initialContactValues,
    updateThirdParty,
    incompleteDetailsMessage,
  } = useServicePayment(jobId);
  const [showRequestPaymentModal, setShowRequestPaymentModal] = useState<boolean>(false);
  const handleFormChange = (field: JsonDataItem) => {
    if (field.paymentMethod) {
      setPaymentMethod(field.paymentMethod);
    }
  };

  return (
    <>
      <title>Service Payment</title>
      <Form
        form={form}
        name="service-payment-form"
        layout="vertical"
        colon={false}
        preserve={false}
        disabled={isLocked}
        onValuesChange={handleFormChange}
      >
        <Space.$ direction={Space.Direction.Vertical} size={Space.Size.ExtraLarge}>
          <Method
            jobId={jobId}
            hasDebt={hasDebt}
            step={step}
            paymentMethod={paymentMethod}
            paymentMethods={paymentMethods}
            hasCard={hasCard}
            isLoading={isDataLoading}
            updateThirdParty={updateThirdParty}
            isLocked={isLocked}
          />
          <Invoice
            jobId={jobId}
            step={step}
            hasDebt={hasDebt}
            invoices={invoices}
            paymentMethod={paymentMethod}
            paymentMethods={paymentMethods}
            isLoading={isDataLoading}
            onRequestPayment={() => setShowRequestPaymentModal(true)}
            onProcessPayment={processPayment}
            incompleteDetailsMessage={incompleteDetailsMessage}
          />
          <Receipt
            receipts={receipts}
            receiptsTotal={receiptsTotal}
            outstandingAmount={outstandingAmount}
            hasDebt={hasDebt}
            paymentMethods={paymentMethods}
            isLoading={isDataLoading}
          />
          <Actions
            jobId={jobId}
            step={step}
            hasCard={hasCard}
            paymentMethod={paymentMethod}
            onSendEmail={sendEmail}
            onGenerateInvoice={generateInvoice}
            onRequestPayment={() => setShowRequestPaymentModal(true)}
            onProcessPayment={processPayment}
            isLocked={isLocked || isDataLoading}
            isLoading={isJobUpdating}
          />
          <RequestPaymentModal
            initialValues={initialContactValues}
            emailOptions={emailOptions}
            smsOptions={smsOptions}
            isOpen={showRequestPaymentModal}
            onCancel={() => {
              setShowRequestPaymentModal(false);
            }}
            onRequest={(contactDetails: JsonDataItem) => {
              requestPayment(contactDetails);
              setShowRequestPaymentModal(false);
            }}
          />
        </Space.$>
      </Form>
    </>
  );
};
